import { jsx, Fragment } from "react/jsx-runtime";
import { memo, Suspense } from "react";
import { useSelector } from "react-redux";
import { selectCustomerTokenLoaded } from "@nxplatform/customer-noauth/slices/customer-token.slice";
import { lazyImport } from "@nxplatform/helpers/helpers";
const { AuthorizationHookPrivate } = lazyImport(
  () => import("./authorization.hook.private.js"),
  "AuthorizationHookPrivate"
);
const AuthorizationHookWrapper = () => {
  const loginSuccess = useSelector(selectCustomerTokenLoaded);
  return /* @__PURE__ */ jsx(Fragment, { children: loginSuccess && /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(AuthorizationHookPrivate, {}) }) });
};
const _AuthorizationHookWrapper = memo(AuthorizationHookWrapper);
export {
  _AuthorizationHookWrapper as AuthorizationHookWrapper
};
